import { Route } from 'react-router-dom';
import Home from './Home/Home';
import ProjectInfo from './ProjectInfo/ProjectInfo';
import ProjectType from './ProjectType/ProjectType';
import Backoffice from './backoffice/Backoffice';
import Template from './Template/Template';
import { DesignCondition, DesignConditionWithId } from './DesignCondition/DesignCondition';
import BackOfficeMaterialCreate from './BackofficeMaterial/BackOfficeMaterialCreate';
import BackOfficeMaterialUpdate from './BackofficeMaterial/BackOfficeMaterialUpdate';

export const endpoint = {
    home: '/',
    projectInfo: '/project-info',
    projectType: '/project-info/project-type',
    template: '/project-info/project-type/template',
    designCondition: '/project-info/project-type/template/designCondition',
    designConditionWithId: '/project-info/project-type/template/designCondition/:id',
    //Backoffice
    backoffice: '/backoffice',
    backofficeMaterial: '/backoffice/material',
    backofficeMaterialWithId: '/backoffice/material/:id',
};

export type TEndpoint = keyof typeof endpoint;

const commonRoutes = () => (
    <>
        <Route path={endpoint.home} element={<Home />} />
        <Route path={endpoint.projectInfo} element={<ProjectInfo />} />
        <Route path={endpoint.projectType} element={<ProjectType />} />
        <Route path={endpoint.template} element={<Template />} />
        <Route path={endpoint.designCondition} element={<DesignCondition />} />
        <Route path={endpoint.designConditionWithId} element={<DesignConditionWithId />} />
        <Route path={endpoint.backoffice} element={<Backoffice />} />
        <Route path={endpoint.backofficeMaterial} element={<BackOfficeMaterialCreate />} />
        <Route path={endpoint.backofficeMaterialWithId} element={<BackOfficeMaterialUpdate />} />
    </>
);

export default commonRoutes();
